// tslint:disable

import * as axios from 'axios';
import { find } from 'lodash';
import * as React from 'react';
import { Environment } from '../../environment/environment';
import { Notification } from '../../index';
import { FormLib } from './form.lib';

export class ResourceLoader extends React.Component<any> {
    public state: any = {
        isInitialized: false
    };
    private form: FormLib;
    private isCreate = false;

    private raw: any;

    public async componentWillMount() {
        this.isCreate = this.props.entityId === 'create';

        try {
            const compact: any = await this.getTree();
            const entity = find(compact, (i: any) => i.iri === this.props.entity);
            this.form = new FormLib(entity);

            this.form.onTriggerFetch$.subscribe(async () => {
                await this.fetchIriItem(this.props.entity, this.props.entityId);
            });

            if (this.props.entity && this.props.entityId && !this.isCreate) {
                try {
                    const defaultFormValues = await this.fetchIriItem(this.props.entity, this.props.entityId);
                    this.raw = defaultFormValues;
                    this.setInitialized();
                    this.form.setFormValues(defaultFormValues, true);
                } catch (e) {
                    console.warn('GENERAL PROBLEM BUT WORKS FINE :(', e);
                }
            }

            this.setInitialized();

        } catch (err) {
            // console.log(err);
        }
    }

    public async fetchIriItem(iri: string, id: any) {
        try {
            const fetched = await axios.default.get(`${Environment.get('api.base')}/${iri}/${id}`, {withCredentials: true});
            return fetched.data || {};
        } catch (err) {
            Notification.errorExec(err);
            return {};
        }
    }

    render() {
        return (this.state.isInitialized) ? this.props.render(this.form, this.raw) : <i className="fa fa-spin fa-2x fa-circle-o-notch"/>;
    }

    public async getTree() {
        return new Promise(async (resolve, reject) => {
            try {
                const response: any = await axios.default.get(Environment.get('api.compact'), {withCredentials: true});
                resolve(response.data.supportedClass);
            } catch (err) {
                reject(err);
            }
        });
    }

    private setInitialized() {
        this.setState({isInitialized: true});
    }
}



// WEBPACK FOOTER //
// ./src/components/libs/resource-loader.tsx